import progressAnimation from '@/assets/animation/blue_dog_loader.json';
import Lottie from 'lottie-react';
import homeLogo from '@/assets/img/logo-icon.svg';
import TextLogo from '@/assets/img/logo-text.svg';
import { useAuth } from '@/lib/auth';
import { API_URL } from '@/config';
import { useEffect, useState } from 'react';
import SuccessAnimation from '@/assets/animation/done.json';
import { useLocation, useNavigate } from 'react-router-dom';
import { useBuisinessBySlug } from '@/features/business/api/getBusinessBySlug';
import appCompoLoading from '@/assets/animation/loading.json';
import { Business } from '@/features/business';
import storage from '@/utils/storage';
import { showNotification } from '@/utils/notificationUtils';
import MicrosoftLogin from '@/assets/img/microsoft-login-icon.svg';
import GoogleLoginFrame from '@/assets/img/google-frame.svg';

import LoginLogo from '@/assets/img/p-logo-r.svg';

let myWindow: any;

type Props = {
  onSuccess: () => void;
};

export const InviteRequestForm = ({ onSuccess }: Props) => {
  const search = useLocation().search;
  const navigate = useNavigate();
  const { login } = useAuth();
  const token = new URLSearchParams(search).get('token');
  const slug = new URLSearchParams(search).get('slug');
  const businessQuery = useBuisinessBySlug({ slugName: slug });
  const [connected, setConnected] = useState(false);

  const [businessData, setBusinessData] = useState<Business>();

  useEffect(() => {
    window.onmessage = (ev: any) => {
      if (ev.data && ev.data.profile) {
        if (myWindow) {
          myWindow.close();
        }
        login({ userData: ev.data.profile });
      } else if (ev.data && ev.data.error && ev.data.error.message) {
        if (myWindow) {
          myWindow.close();
        }
        showNotification({
          type: 'error',
          title: ev.data.error.message,
        });
      }
    };
  }, []);
  useEffect(() => {
    setBusinessData(businessQuery.data);
  }, [businessQuery.data]);

  if (businessQuery.isLoading || !token || !slug) {
    return (
      <div className="h-full w-full flex items-center justify-center loader-animation-user">
        <Lottie className="hw-60" animationData={appCompoLoading} />
      </div>
    );
  }

  return (
    <>
      <div className="p-login login-step-1">
        <div className="left-login">
          <div className="login-block invite-block-width">
            <div className="logo-outer-p">
              <img src={LoginLogo} className="logo-r" />
            </div>
            {connected || storage.getKey('isInvite') == 'true' ? (
              <>
                <div className="loti-animation">
                  <Lottie loop={false} className="h-200-W-200" animationData={SuccessAnimation} />
                </div>
                <div className="top-text-title invite-text-font">
                  Your calendar is now successfully connected to
                  <span className="red-text-title invite-red-text-font">{businessData?.name}</span>
                  <br />
                </div>
                <div
                  onClick={async () => {
                    storage.clearKey('isInvite');
                    navigate('/');
                  }}
                  className="Online-realtime cursor-pointer"
                >
                  <u> Go to App </u>
                </div>
              </>
            ) : (
              <>
                <div className="top-text-title invite-text-font">
                  Connect your calendar to{' '}
                  <span className="red-text-title invite-red-text-font">{businessData?.name}</span>
                  <br />
                  so we can start scheduling appointments{' '}
                </div>
                <div className="pet-text-desc"></div>

                <div className="login-btn-outer-new-figma-full-size">
                  <button
                    type="button"
                    className={`google-btn-style`}
                    style={{ marginBottom: 10 }}
                    onClick={() => {
                      const width = 530;
                      const height = 762;
                      const left = window.screen.width / 2 - width / 2;
                      const top = window.screen.height / 2 - height / 2;
                      const windowFeatures = `toolbar=0, status=0, width=${width}, height=${height}, top=${top}, left=${left}`;
                      myWindow = window.open(
                        `${API_URL}/auth/google?invite_token=` + token,
                        `Login with Google`,
                        windowFeatures
                      );
                    }}
                  >
                    <span className="google-icon-css">
                      <img src={GoogleLoginFrame} />
                    </span>
                    <span>{`Sign-in with Google`}</span>
                  </button>
                </div>

                <div className="or-div">OR</div>
                <div className="login-btn-outer-new-figma-full-size">
                  <button
                    type="button"
                    className={`microsoft-btn-style`}
                    style={{ marginBottom: 10 }}
                    onClick={() => {
                      const width = 530;
                      const height = 762;
                      const left = window.screen.width / 2 - width / 2;
                      const top = window.screen.height / 2 - height / 2;
                      const windowFeatures = `toolbar=0, status=0, width=${width}, height=${height}, top=${top}, left=${left}`;
                      myWindow = window.open(
                        `${API_URL}/auth/microsoft?invite_token=` + token,
                        `Login with Microsoft`,
                        windowFeatures
                      );
                    }}
                  >
                    <span>
                      <img src={MicrosoftLogin} className="microsoft-icon-css" />
                    </span>
                    <span>{`Sign-in with Microsoft`}</span>
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {/* <div className="home-page">
      <div className="home-brand-logo-outer">
        <img src={homeLogo} className="home-brand-logo" />
      </div>
      <div className="home-brand-text-outer">
        <img src={TextLogo} className="home-brand-text" />
      </div>
      {connected || storage.getKey('isInvite') == 'true' ? (
        <>
          <div className="loti-animation">
            <Lottie loop={false} className="h-200-W-200" animationData={SuccessAnimation} />
          </div>
          <div className="Online-realtime">
            Your calendar is now successfully connected to <br />
            <strong>{businessData?.name}</strong>
          </div>
          <div
            onClick={async () => {
              storage.clearKey('isInvite');
              navigate('/');
            }}
            className="Online-realtime cursor-pointer"
          >
            <u> Goto App </u>
          </div>
        </>
      ) : (
        <>
          <div className="Online-realtime">
            Connect your calendar to <strong>{businessData?.name}</strong>
            <br /> so we can start scheduling appointments{' '}
          </div>
          <div className="login-btn-outer login-buttons">
            {
              ['google', 'microsoft'].map(network => {
                return <button
                  type="button"
                  className={`${network}-btn-style`}
                  onClick={() => {
                    const width = 548;
                    const height = 325;
                    const left = window.screen.width / 2 - width / 2;
                    const top = window.screen.height / 2 - height / 2;
                    const windowFeatures = `toolbar=0, status=0, width=${width}, height=${height}, top=${top}, left=${left}`;
                    myWindow = window.open(
                      `${API_URL}/auth/${network}?invite_token=` + token,
                      `Login with ${network === 'microsoft' ? 'Microsoft' : 'Google'}`,
                      windowFeatures
                    );
                  }}
                >
                  <span>{`Login with ${network === 'microsoft' ? 'Microsoft' : 'Google'}`}</span>
                </button>
              })
            }
          </div>
        </>
      )
      }
    </div > */}
    </>
  );
};
